import { render, staticRenderFns } from "./CustomFieldLabel.vue?vue&type=template&id=6d6cc90a"
import script from "./CustomFieldLabel.vue?vue&type=script&lang=js"
export * from "./CustomFieldLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports